<script setup lang="ts">
import PMenu from 'primevue/menu'
import PBadge from 'primevue/badge'
import { cn } from '@/lib/utils'
import type { MenuItem } from 'primevue/menuitem'
const props = withDefaults(
  defineProps<{ items: DMenuItem[]; popup?: boolean; submenuClass?: string }>(),
  {
    popup: false,
  }
)

const menu = ref()
const toggle = (event: Event) => {
  menu.value.toggle(event)
}

const route = useRoute()
const isCurrent = (item: MenuItem) => {
  if (item.to === '/') {
    return route.path === item.to
  }

  return route.path.startsWith(item.to as string)
}
</script>

<template>
  <!-- tailwind presetが入ったらDBtnにv-bind="props.action"を付与-->
  <slot name="trigger" :on="{ click: toggle }"></slot>
  <PMenu
    v-bind="$attrs"
    :model="items"
    ref="menu"
    :popup="popup"
    class="px-0"
    :pt="{
      submenuLabel: {
        class: cn('px-2 font-medium text-xs pt-2 pb-0.5', submenuClass),
      },
      itemContent: { class: 'rounded-none px-0' },
      list: { class: 'gap-0 p-2' },
    }"
  >
    <template #item="{ item, props }">
      <DBtn
        text
        plain
        size="small"
        :to="item.to"
        :target="item.target"
        :download="item.downloadName"
        class="!justify-start !w-full !ring-0 focus:outline-0 gap-1"
        :class="cn(isCurrent(item) ? '!bg-slate-300' : '')"
        @click="item.myCommand"
        :disabled="item.btnDisabled ? true : false"
      >
        <component
          v-if="item.iconComponent"
          :is="item.iconComponent"
          stroke-width="1.3"
          size="20"
          class="ml-[-2px] mr-[-3px]"
        ></component>
        <i v-if="item.pIconClass" :class="item.pIconClass"></i>
        <span class="pl-1">{{ item.label }}</span>
        <PBadge v-if="item.badge" :value="item.badge" class="ml-auto" />
      </DBtn>
    </template>
  </PMenu>
</template>
